module.exports = __webpack_public_path__ + "static/img/oneab.abe17a33.png";